import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import { Button, Icon, Confirm, Header } from 'semantic-ui-react';
import { ADD_QUANTITY, DELETE_ITEM_MODAL_CONTENT, DELETE_ITEM_MODAL_HEADER, SUBTRACT_QUANTITY } from './CartItemQuantityButton.constants';
import './CartItemQuantityButton.css';
var defaultProps = {
  loading: false
};
function CartItemQuantityButton(_ref) {
  var quantity = _ref.quantity,
    onDelete = _ref.onDelete,
    onUpdateQuantity = _ref.onUpdateQuantity,
    loading = _ref.loading;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showDeleteModal = _useState2[0],
    setShowDeleteModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDeleting = _useState4[0],
    setIsDeleting = _useState4[1];
  function handleIncrementItemQuantity() {
    return _handleIncrementItemQuantity.apply(this, arguments);
  }
  function _handleIncrementItemQuantity() {
    _handleIncrementItemQuantity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return onUpdateQuantity(ADD_QUANTITY);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _handleIncrementItemQuantity.apply(this, arguments);
  }
  function handleDecrementItemQuantity() {
    return _handleDecrementItemQuantity.apply(this, arguments);
  }
  function _handleDecrementItemQuantity() {
    _handleDecrementItemQuantity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return onUpdateQuantity(SUBTRACT_QUANTITY);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _handleDecrementItemQuantity.apply(this, arguments);
  }
  function handleRemoveItemFromCart() {
    return _handleRemoveItemFromCart.apply(this, arguments);
  }
  function _handleRemoveItemFromCart() {
    _handleRemoveItemFromCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            setIsDeleting(true);
            _context3.next = 4;
            return onDelete();
          case 4:
            setIsDeleting(false);
            _context3.next = 10;
            break;
          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            setIsDeleting(false);
          case 10:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 7]]);
    }));
    return _handleRemoveItemFromCart.apply(this, arguments);
  }
  function displayDeleteModal() {
    setShowDeleteModal(true);
  }
  function onCancelDelete() {
    setShowDeleteModal(false);
  }
  var onlyOneItem = quantity === 1;
  return /*#__PURE__*/React.createElement("div", {
    className: "cart-item-quantity-button-container"
  }, /*#__PURE__*/React.createElement(Confirm, {
    className: "delete-cart-item-modal",
    open: showDeleteModal,
    onCancel: onCancelDelete,
    onConfirm: handleRemoveItemFromCart,
    header: /*#__PURE__*/React.createElement(Header, null, DELETE_ITEM_MODAL_HEADER, /*#__PURE__*/React.createElement(Icon, {
      name: "close",
      onClick: onCancelDelete,
      disabled: isDeleting
    })),
    content: DELETE_ITEM_MODAL_CONTENT,
    dimmer: "inverted",
    size: "tiny",
    closeOnEscape: true,
    closeOnDimmerClick: false,
    cancelButton: /*#__PURE__*/React.createElement(Button, {
      content: "CANCEL",
      disabled: isDeleting
    }),
    confirmButton: /*#__PURE__*/React.createElement(Button, {
      primary: true,
      content: "CONFIRM",
      disabled: isDeleting,
      loading: isDeleting
    })
  }), /*#__PURE__*/React.createElement(Button, {
    icon: true,
    className: "modifier-button",
    onClick: onlyOneItem ? displayDeleteModal : handleDecrementItemQuantity,
    disabled: loading
  }, /*#__PURE__*/React.createElement(Icon, {
    name: onlyOneItem ? 'trash' : 'minus',
    className: "modifier-icon"
  })), quantity, /*#__PURE__*/React.createElement(Button, {
    icon: true,
    className: "modifier-button",
    onClick: handleIncrementItemQuantity,
    disabled: loading
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "plus",
    className: "modifier-icon"
  })));
}
CartItemQuantityButton.defaultProps = defaultProps;
export default CartItemQuantityButton;